import React from "react";
import { PageHeader, ActionBar } from "@/components/PageBits";
import { Wrench, TicketCheck, Building2, Users, CalendarClock, Clock, BarChart3, MessagesSquare, History } from "lucide-react";

const PAGES = {
  dashboard: { title: "Ticket Disposition", icon: TicketCheck, subtitle: "Übersicht offener Tickets, Terminierung und Kapazitäten" },
  tickets: { title: "GWV Tickets", icon: TicketCheck, subtitle: "Ticket-Erfassung, Status, Zuweisung" },
  kunden: { title: "Kundenkontakt", icon: MessagesSquare, subtitle: "Anrufe, Nachrichten, Ticket-Historie pro Kunde" },
  termine: { title: "Terminierung", icon: CalendarClock, subtitle: "Termine planen, Kapazitäten prüfen, bestätigen" },
  partner: { title: "Partnerfirmen", icon: Building2, subtitle: "Subunternehmer verwalten, SLAs, Ansprechpartner" },
  kapazitaeten: { title: "Kapazitäten", icon: BarChart3, subtitle: "Freie Slots je Team/Region/Datum" },
  abwesenheiten: { title: "Abwesenheiten", icon: Clock, subtitle: "Urlaub, Krank, Sonstiges" },
  mitarbeiter: { title: "Techniker", icon: Users, subtitle: "Team, Kompetenzen, Verfügbarkeit" },
  berichte: { title: "Berichte", icon: BarChart3, subtitle: "SLA-Kennzahlen, Ticket-Statistiken" },
  audit: { title: "Audit Log", icon: History, subtitle: "Unveränderliches Protokoll aller Änderungen" },
};

export default function TicketPlaceholder({ pageKey }) {
  const cfg = PAGES[pageKey] || PAGES.dashboard;
  const Icon = cfg.icon;
  return (
    <div data-testid={`ticket-page-${pageKey}`}>
      <PageHeader title={cfg.title} subtitle={cfg.subtitle} />
      <div
        className="bg-white border rounded-md p-12 text-center"
        style={{ borderColor: "#E2E8F0" }}
      >
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-md mb-5" style={{ background: "#F1F5F9" }}>
          <Icon className="h-8 w-8" style={{ color: "#0A2540" }} />
        </div>
        <h2 className="text-xl font-bold">{cfg.title}</h2>
        <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">{cfg.subtitle}</p>
        <div className="inline-flex items-center gap-2 mt-6 px-4 py-2 rounded-md bg-amber-50 border border-amber-200 text-amber-800 text-xs font-semibold">
          <Wrench className="h-4 w-4" /> In Vorbereitung — folgt in Kürze
        </div>
      </div>
      <ActionBar hideNext onPrint={() => window.print()} />
    </div>
  );
}
